
import helpMask from './src/main.js'


/**
 * [usage]
 * this.$helpMask()
 * this.$helpMask.open()
 * 组件内关闭
 * this.$helpMask.close()
 * 组件外关闭 `outerClose`过渡动画完成时自动触发`close`
 * this.$helpMask.outerClose()
 */
export default {
    install(Vue, alias = '$helpMask') {
        Object.defineProperty(Vue.prototype, alias, {
            value: helpMask
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/uimask/index.js